import React, { useEffect, useState } from "react";
import { ServiceChosen } from "./Utils/CustomerLabelInput";
import SelectMenuItem from "./Component/SelectMenuItem";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomerDetail } from "../../../store/reducers/digitalmarketing/customer";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { specialChractorValidation } from "./Utils/validation";
import { useGetTreatmentsQuery } from "../../../Service/treatments";
import SelectMultiItem from "./Component/SelectMultiItem";
import { useGetWellnessCategoryQuery } from "../../../Service/wellnessTips";
import Checkbox from "./Component/Checkbox";
import { log } from "console";
import SelectSingleItem from "./Component/SelectSingleItem";
function CustomerStatus(props) {
  const { callBackforErrorMessage, openSnackBar,view } = props;
  const [selectedServiceChoosen, setSelectedServiceChoosen] = useState([]);
  const dispatch = useDispatch();
  const CustomerDetail = useSelector(
    (state: any) => state.customer.customerDetail
  );
  // console.log(CustomerDetail);
  const [pagination, setpagination] = useState(1);

  const pagi = {
    pageNo: pagination,
   
  };
  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  const [updateCustomer] = useUpdateCustomerMutation();
  const { data: TreatmentResponse, refetch } =  useGetTreatmentsQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });  const [wellnessStatus, setwellnessStatus] = useState(
    CustomerDetail?.wellnessTips === 1 ? 1 : 0
  );
  useEffect(() => {
    
  }, [pagination])

  const [tips, settips] = useState([]);
  const { data: category }: any = useGetWellnessCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  // console.log("category", category);
  const account = useSelector((state: any) => state.auth);
// console.log(account);
// console.log(category);

  const activeCategories =
    category && category.filter((category) => category.activeStatus === 1);

  const Option_list = activeCategories;
// console.log(Option_list);
  

  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.id,
    icon: (
      <span
        style={{ backgroundColor: item.others }}
        className="blue me-2"
      ></span>
    ),
  }));
// console.loggggg(status);
  
  useEffect(() => {
    CustomerDetail.serviceChoosen &&
      setSelectedServiceChoosen(CustomerDetail.serviceChoosen);
  }, [CustomerDetail]);

  const getValueByLabel = (label) => {
    let val = status.find((item) => item.label == label);
    if (val) {
      return val.value;
    }
    return 0;
  };
  const getLabelByValue = (value) => {
    let val = status.find((item) => item.value == value);
    if (val) {
      return val.label;
    }
    return "Created";
  };
  const onSelectServiceChoosen = (value) => {
    if (
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail.customerName )
    ) {
      if (CustomerDetail.id) {
        if (selectedServiceChoosen?.includes(value)) {
          setSelectedServiceChoosen(
            selectedServiceChoosen.filter((item) => item !== value)
          );
          dispatch(
            updateCustomerDetail({
              serviceChoosen: selectedServiceChoosen
                .filter((item) => item !== value)
                .join(","),
            })
          );
          updateCustomer({
            id: CustomerDetail.id,
            serviceChoosen: selectedServiceChoosen
              .filter((item) => item !== value)
              .join(","),
          });
        } else {
          setSelectedServiceChoosen([value]);
          dispatch(
            updateCustomerDetail({
              serviceChoosen: value,
            })
          );

          updateCustomer({
            id: CustomerDetail.id,
            serviceChoosen: value.toString(),
          });
        }
      }
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };
  const x = document.getElementById("wellness_status");
  // console.log(x)

  const handleChangeInfo = (event) => {
    const { name, value, checked } = event.target;

    const x = checked ? 1 : 0;
    setwellnessStatus(x);

    // console.log(wellnessStatus);

    if (wellnessStatus) {
      const x = [];
      settips(x);
      dispatch(
        updateCustomerDetail({
          wellnessCategory: "",
          wellnessTips: 0,
        })
      );
      updateCustomer({
        id: CustomerDetail.id,
        wellnessCategory: "",
        wellnessTips: 0,
      });
    }
  };
  const handleSelectChange = (event) => {
    const { name, value } = event.target;

    if (
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail.customerName)
    ) {
      // console.log("stat");

      if (CustomerDetail.id) {
        dispatch(
          updateCustomerDetail({
            customerStatus: getLabelByValue(value),
          })
        );
        updateCustomer({
          id: CustomerDetail.id,
          customerStatus: getLabelByValue(value),
        });
      }
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };
// console.log(wellnessStatus || CustomerDetail.wellnessTips === 1);
// console.log(wellnessStatus);
// console.loggg(CustomerDetail.wellnessTips === 1);
// console.log(CustomerDetail.wellnessTips);

  const handleCheckboxStatus = () => {
    const st = CustomerDetail.wellnessTips ? 1 : 0;
    setwellnessStatus(st);
  };
// console.log(CustomerDetail?.wellnessTips);
  if (CustomerDetail?.wellnessTips === 1) {
  // console.log(CustomerDetail);
  }
  const handleSelectCategoryChange = (x) => {
    // console.log("checked");
    // console.log(CustomerDetail.id);

    if (
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail.customerName)
    ) {
      if (CustomerDetail.id) {
        dispatch(
          updateCustomerDetail({
            wellnessCategory: JSON.stringify(x),
            wellnessTips: wellnessStatus,
          })
        );
        updateCustomer({
          id: CustomerDetail.id,
          wellnessCategory: JSON.stringify(x),
          wellnessTips: wellnessStatus,
        });
      }
    }
  };

// console.loggg(TreatmentResponse, "ServiceChosen");
// console.log("length",TreatmentResponse?.length);
const ActiveService = [];

if (TreatmentResponse ) {
  for (const service of TreatmentResponse) {
    if (service.active_status === 1) {
      ActiveService.push(service);
    }
  }
}
// console.log(ActiveService);

  return (
    <>
      <li>
        <span className="title mb-1">Status *</span>
      </li>

      <li>
        <SelectMenuItem
          styles={"select"}
          view={view}

          name="status"
          option={status}
          value={getValueByLabel(CustomerDetail.customerStatus)}
          onChange={handleSelectChange}
        />
      </li>

      {/* <li>
     
        <SelectMultiItem styles={"select"} name="tips" option={status} value={getLabelByValuetip(CustomerDetail.customerStatus)} onChange={handleSelectChange} />
      
      </li> */}

      {/* <li className="mt-2">
        <span className="title mb-1">Service Chosen *</span>
      </li>
      <li className="status-service">
        <div>
        
          {TreatmentResponse?.length!==0 && TreatmentResponse?.map((a, i) =>
            a.active_status === 0 ? null : selectedServiceChoosen?.includes(
                a.treatment_type_name
              ) ? (
              <span
                onClick={!view ?(() => onSelectServiceChoosen(a.treatment_type_name)):null}
                style={{
                  border: "1px solid #6842D9",
                  color: "#6842D9",
                  cursor: !view?"pointer":"context-menu",
                }}
                key={i}
              >
                {a.treatment_type_name}
              </span>
            ) : (
              <span
              onClick={!view ?(() => onSelectServiceChoosen(a.treatment_type_name)):null}
              key={i}
                style={{ color: "black",    cursor: !view?"pointer":"context-menu",
              }}
              >
                {a.treatment_type_name}
              </span>
            )
          )}
           {ActiveService?.length===0 &&
           <p style={{fontSize:"12px",textAlign:"center",marginBlock:"10px"}} >No Active Service Found</p>
}
        </div>
       
      </li> */}
      {/* account.permissions.wellness_status===1 && */}
      {category?.length >= 0 && (
        <li>
          <Checkbox
            label="Wellness tips"
            name="wellness_status"
            id="wellness_status"
            view={view}
            {...CustomerDetail}
            handleChange={handleChangeInfo}
            checkboxstatus={handleCheckboxStatus}
          />
          {(wellnessStatus || CustomerDetail.wellnessTips === 1) && (
            <>
            {/* <SelectMultiItem
              styles={"select"}
              label={"Wellness Status"}
              name="wellnessCategory"
              option={Option_list}
              {...CustomerDetail}
              onChange={handleSelectCategoryChange}
              tips={tips}
              list_name={"categoryName"}
              settips={settips}
              ids={"id"}
            /> */}
            <SelectSingleItem
                          styles={"select"}

            label="Wellness category *"
            view={view}

            name="wellnessCategory"
            option={Option_list}
            {...CustomerDetail}

            onChange={handleSelectCategoryChange}
            tips={tips}
            list_name={"categoryName"}
            settips={settips}
            ids={"id"}
            disabled={false}
          /></>
          )}
        </li>
      )}
    </>
  );
}

export default CustomerStatus;
